"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = TextBlock;

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _commonRichText = require("@mmc/common-rich-text");

var _text = require("@mmc/text");

var _m = _interopRequireDefault(require("../styles/m-43.css"));

var _m2 = _interopRequireDefault(require("./m-43.props/m-43.defaultProps"));

var _m3 = _interopRequireDefault(require("./m-43.props/m-43.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var getCtaData = function getCtaData(data) {
  return {
    url: handleNestedProp(data, 'data.cta.URL'),
    label: handleNestedProp(data, 'data.cta.label'),
    priority: handleNestedProp(data, 'data.cta.priority'),
    ctaTheme: handleNestedProp(data, 'data.theme'),
    openNewTab: handleNestedProp(data, 'data.cta.openNewTab'),
    icon: handleNestedProp(data, 'data.cta.icon')
  };
};

var getHeading1Margin = function getHeading1Margin(textBlockPosition) {
  return textBlockPosition === 'right' ? _m["default"].heading1 : '';
};

var getHeading2Margin = function getHeading2Margin(data) {
  if (!data.heading1) {
    return getHeading1Margin(data.textBlockPosition);
  }

  return _m["default"].marginTop24;
};

function TextBlock(_ref) {
  var data = _ref.data,
      theme = _ref.theme;
  var heading1Margin = (0, _react.useMemo)(function () {
    return getHeading1Margin(data.textBlockPosition);
  }, [data.textBlockPosition]);
  var heading2Margin = (0, _react.useMemo)(function () {
    return getHeading2Margin(data);
  }, [data]);
  var ctaData = (0, _react.useMemo)(function () {
    return getCtaData(data);
  }, [data]);
  var shouldRenderCta = (0, _react.useMemo)(function () {
    return !!ctaData.label;
  }, [ctaData]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _m["default"].textWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _m["default"].content
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.heading1'),
    className: theme.labelMedium + " " + _m["default"].greyButton + " " + heading1Margin,
    tag: "h2",
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.heading2'),
    className: theme.headingThree + " " + heading2Margin,
    tag: "h3",
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: handleNestedProp(data, 'data.textBlock'),
      className: theme.bodyCopy + " " + _m["default"].marginTop24,
      tagName: "p"
    }),
    disclaimerData: handleNestedProp(data, 'data.disclaimerData'),
    className: "" + _m["default"].greyButton
  }), shouldRenderCta && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: ctaData,
    spanClasses: _m["default"].displayInlineB + " " + _m["default"].marginTop32
  })));
}

TextBlock.displayName = 'TextBlock';
TextBlock.defaultProps = {
  data: _m2["default"]
};